import * as React from 'react';
import { PrimaryIdentityInfo } from '../../backend/interfaces/IAuthenticationProvider';
import { IsPrimaryIdentityInformationValid } from '../../backend/office-js/auth/IdentityUtil';
import { HostAppSettingName, HostAppSettings } from '../../backend/office-js/HostAppSettings';
import { AppLayoutSettings } from '../common/styles/common.styles';

export function getPrimaryAccountInfoString(primaryIdentity: PrimaryIdentityInfo | null): JSX.Element {
  return <div>
    <p>{ TranscriptionStrings.PrimaryOneDriveAccountInfoForAudioUpload + ':' }
      <br></br>
      <div style={ AppLayoutSettings.AppCommonStyles.getPrimaryAccountInfoStringStyles() }>
        { primaryIdentity?.displayName + ' (' + primaryIdentity?.email + ')' }
      </div>
    </p>
  </div>
}

export function getPrimaryAccountInfoStringForLandingPage(primaryIdentity: PrimaryIdentityInfo | null): JSX.Element {
  return <div>
    <p>{ TranscriptionStrings.PrimaryOneDriveAccount + ':' }
      <br></br>
      <div style={ AppLayoutSettings.AppCommonStyles.getPrimaryAccountInfoStringStyles() }>
        { primaryIdentity?.displayName + ' (' + primaryIdentity?.email + ')' }
      </div>
    </p>
  </div>
}

export function shouldShowOnedriveInfobar(primaryIdentity: PrimaryIdentityInfo | null) {

  // We will show this OneDrive info dialog if it is activated by the client
  return HostAppSettings.IsSettingTrue(HostAppSettingName.ShouldShowOneDriveIdentityInfoDialog) && IsPrimaryIdentityInformationValid(primaryIdentity);
}